// extracted by mini-css-extract-plugin
export default {"container":"WaUF","select":"ej84","number":"vLrL","notification":"MBJT"};